import { Contract, Granularity, PeriodRow, SupplyPoint } from "../types";
import { ReturnDerived, Totals } from "../helpers";
import { BankingContractAnalyticsBucket } from "../../../../models/banking";
import { KpiRow } from "../components/KpiRow";
import { ReturnKpiRow } from "../components/ReturnKpiRow";
import { SupplyChart } from "../components/SupplyChart";
import { PeriodBreakdownTable } from "../components/PeriodBreakdownTable";

export function OverviewTab({
  contract,
  totals,
  returnRequired,
  avgReturn,
  series,
  granularity,
  setGranularity,
  rows,
  returnDerived,
  blocksByDate,
}: {
  contract: Contract;
  totals: Totals;
  returnRequired: number;
  avgReturn: number;
  series: SupplyPoint[];
  granularity: Granularity;
  setGranularity: (g: Granularity) => void;
  rows: PeriodRow[];
  returnDerived?: ReturnDerived | null;
  blocksByDate?: Record<string, BankingContractAnalyticsBucket[]>;
}) {
  const isTimeBlock = granularity === "Time Block";

  const allRows = [...rows, ...(returnDerived?.rows ?? [])];
  const showApprovalNos = allRows.some((r) => (r.approval_nos ?? []).length > 0);
  const showCategories = allRows.some((r) => (r.categories ?? []).length > 0);

  return (
    <div className="flex flex-col">
      <KpiRow
        contract={contract}
        totals={totals}
        returnRequired={returnRequired}
        avgReturn={avgReturn}
      />
      <SupplyChart
        series={series}
        granularity={granularity}
        setGranularity={setGranularity}
        receiver={contract.to}
      />
      <PeriodBreakdownTable
        rows={isTimeBlock ? rows : rows.slice(0, 14)}
        contractId={contract.id}
        enableExpand={granularity === "Day" || isTimeBlock}
        preloadedBlocks={isTimeBlock ? blocksByDate : undefined}
        granularity={granularity}
        showApprovalNos={showApprovalNos}
        showCategories={showCategories}
      />

      {returnDerived && (
        <>
          <div className="mt-2 mb-2 flex items-center gap-2">
            <span className="h-px flex-1 bg-[#E8EAEF]" />
            <span className="text-[12px] font-semibold tracking-wider text-[#828A99] uppercase">
              Return
            </span>
            <span className="h-px flex-1 bg-[#E8EAEF]" />
          </div>
          <ReturnKpiRow metrics={returnDerived.metrics} />
          <SupplyChart
            series={returnDerived.series}
            granularity={granularity}
            setGranularity={setGranularity}
            title={`Return To ${contract.from}`}
          />
          <PeriodBreakdownTable
            rows={isTimeBlock ? returnDerived.rows : returnDerived.rows.slice(0, 14)}
            contractId={contract.id}
            enableExpand={granularity === "Day" || isTimeBlock}
            preloadedBlocks={isTimeBlock ? returnDerived.blocksByDate : undefined}
            mode="return"
            title="Return breakdown"
            granularity={granularity}
            showApprovalNos={showApprovalNos}
            showCategories={showCategories}
          />
        </>
      )}
    </div>
  );
}

export default OverviewTab;
